import React, { Component } from "react";
import host from "./host";
import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const USER_ID = 45;

const mockData = {
  rejected_orders: 25,
  cancel_orders: 12,
  confirmed_orders: 150,
  watting_orders: 30,
  all_orders: 217,
  Percentage: 69.1,
  role: 1,
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: mockData,
      upsellsData: null,
      loading: false,
      error: null,
      showStats: false,
      showSearch: false,
      showUpsellsReport: false,
      searchValue: "",
      role: 1,
      name: "المستخدم",
      userId: USER_ID,
      userProfile: null,
      userDataLoading: true,
      showInactiveWarning: false, // تحذير عدم استقبال الطلبات
    };
  }

  componentDidMount() {
    this.getUserData();
  }

  getUserData = async () => {
    this.setState({ userDataLoading: true });
    const header = {
      "Content-Type": "application/json",
      Authorization: cookies.get("token")
    };

    try {
      const response = await axios.get(host + `users/auth/profile`, { headers: header });
      
      if (response.data.data.profile.isActive == true) {
        window.location.href = "/login";
      }
      this.setState({
        userProfile: response.data.data.profile,
        userDataLoading: false,
        name: response.data.data.profile.name,
        userId: response.data.data.profile.id,
        role: response.data.data.profile.role,
        // إظهار التحذير للكول سنتر إذا كان غير نشط
        showInactiveWarning: response.data.data.profile.role === 0 && !response.data.data.profile.isOn
      });
    } catch (error) {
        window.location.href = "/login";
      this.setState({ userDataLoading: false });
    }
  }

  formatTime = (timeValue) => {
    if (!timeValue || timeValue === 0) return "غير محدد";

    if (typeof timeValue === 'number') {
      const hours = Math.floor(timeValue);
      const minutes = Math.floor((timeValue - hours) * 60);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    return timeValue.toString();
  }

  formatDate = (dateString) => {
    if (!dateString) return "غير محدد";

    try {
      const date = new Date(dateString);
      return date.toLocaleString('ar-IQ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return "غير محدد";
    }
  }

  getRoleText = (role) => {
    switch (role) {
      case 0: return "كول سنتر";
      case 1: return "استجابة";
      case 3: return "متابعة";
      default: return "غير محدد";
    }
  }

  fetchUpsellsData = async () => {
    this.setState({ loading: true, error: null });

    try {
      const url = `${host}users/user-orders-reports/${this.state.userId}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      const transformedData = this.transformApiData(data);

      this.setState({
        upsellsData: transformedData,
        loading: false
      });

    } catch (error) {
      console.error('❌ خطأ في تحميل البيانات:', error);
      this.setState({
        error: error.message,
        loading: false
      });
    }
  };

  transformApiData = (apiData) => {
    const userData = apiData.userReport || apiData;

    return {
      userReport: {
        userId: userData?.userId || USER_ID,
        userName: userData?.userName || "المستخدم",
        userPhone: userData?.userPhone || "غير محدد",
        userPercentage: userData?.userPercentage || 0,
        totalUpsellsOrders: userData?.totalUpsellsOrders || 0,
        totalCommission: userData?.totalCommission || 0,
        averageCommissionPerOrder: userData?.averageCommissionPerOrder || 0,
        orderDetails: userData?.orderDetails || []
      },
      summary: {
        totalUsers: 1,
        totalOrders: userData?.totalUpsellsOrders || 0,
        totalCommission: userData?.totalCommission || 0,
        averageCommissionPerUser: userData?.totalCommission || 0
      }
    };
  };

  handleSearch = () => {
    const { searchValue } = this.state;
    if (searchValue.trim()) {
      window.location.href = `/search?number=${searchValue.replace(/\s/g, "")}`;
    }
  };

  handleLogout = () => {
    window.location.href = "/login";
  };

  toggleStats = () => {
    this.setState({ showStats: !this.state.showStats });
  };

  toggleSearch = () => {
    this.setState({ showSearch: !this.state.showSearch });
  };

  toggleUpsellsReport = () => {
    const newState = !this.state.showUpsellsReport;
    this.setState({ showUpsellsReport: newState });

    if (newState) {
      this.fetchUpsellsData();
    }
  };

  handleSearchInputChange = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  closeInactiveWarning = () => {
    this.setState({ showInactiveWarning: false });
  };

  formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-IQ', {
      style: 'currency',
      currency: 'IQD'
    }).format(amount);
  };

  render() {
    const {
      data,
      upsellsData,
      loading,
      error,
      showStats,
      showSearch,
      showUpsellsReport,
      searchValue,
      userProfile,
      userDataLoading,
      showInactiveWarning
    } = this.state;

    const menuItems = [
      {
        title: "انشاء طلب جديد",
        description: "إضافة طلب جديد للنظام",
        link: "/From",
        icon: "📝",
        color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      },
      {
        title: "تقرير عمولات المبيعات الإضافية",
        description: "عرض تفصيلي لعمولات الـ Upsells",
        action: this.toggleUpsellsReport,
        icon: "💰",
        color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
        roleRestriction: 0 // فقط لكول سنتر
      },
      {
        title: "طلب مواد غير متوفرة",
        description: "إدارة المواد غير المتوفرة",
        link: "/outofstock",
        icon: "📦",
        color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      },
      {
        title: "بحث عن طلب",
        description: "البحث باستخدام رقم الوصل أو الهاتف",
        action: this.toggleSearch,
        icon: "🔍",
        color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      },
      {
        title: "طلبات قيد الانتظار",
        description: "عرض الطلبات المعلقة",
        link: "/Orders",
        icon: "⏳",
        color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      },
      {
        title: "معالجة الطلبات",
        description: "إدارة ومعالجة الطلبات",
        link: "/Support",
        icon: "⚙️",
        color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      },
      {
        title: "تأكيد الطلبات",
        description: "تأكيد ومراجعة الطلبات",
        link: "/check",
        icon: "✅",
        color: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
      },
      {
        title: "طلبات لا يرد على الهاتف",
        description: "إدارة الطلبات غير المجابة",
        link: "/Miss",
        icon: "📞",
        color: "linear-gradient(135deg, #c471f5 0%, #fa71cd 100%)",
      }
    ];

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        direction: 'rtl',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans Arabic", sans-serif',
        position: 'relative'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 25px 25px, rgba(255,255,255,0.1) 2px, transparent 0),
            radial-gradient(circle at 75px 75px, rgba(255,255,255,0.05) 2px, transparent 0)
          `,
          backgroundSize: '100px 100px',
          zIndex: 0
        }} />

        {/* Header */}
        <header style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          borderBottom: '1px solid rgba(255,255,255,0.2)',
          position: 'relative',
          zIndex: 10
        }}>
          <div style={{
            maxWidth: '1400px',
            margin: '0 auto',
            padding: '1rem 2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '80px',
            flexWrap: 'wrap',
            gap: '1rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.8rem',
                boxShadow: '0 10px 25px rgba(102, 126, 234, 0.3)'
              }}>
                🏢
              </div>
              <div>
                <h1 style={{
                  fontSize: 'clamp(1.5rem, 4vw, 2.2rem)',
                  fontWeight: '800',
                  color: '#2d3748',
                  margin: 0,
                  lineHeight: '1.2'
                }}>
                  لوحة التحكم الرئيسية
                </h1>
                <p style={{
                  fontSize: '0.9rem',
                  color: '#718096',
                  margin: '0.3rem 0 0 0',
                  fontWeight: '500'
                }}>
                  إدارة شاملة للطلبات والمبيعات والتقارير
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <button
                onClick={this.toggleStats}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 20px rgba(79, 172, 254, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 5px 15px rgba(79, 172, 254, 0.3)';
                }}
                style={{
                  padding: '0.8rem 1.5rem',
                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '15px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 5px 15px rgba(79, 172, 254, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                📊 الإحصائيات
              </button>

              <button
                onClick={this.handleLogout}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 20px rgba(250, 112, 154, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 5px 15px rgba(250, 112, 154, 0.3)';
                }}
                style={{
                  padding: '0.8rem 1.5rem',
                  background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '15px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 5px 15px rgba(250, 112, 154, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                🚪 خروج
              </button>
            </div>
          </div>
        </header>

        {/* User Info Bar */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '2rem',
          position: 'relative',
          zIndex: 5
        }}>
          {userProfile && !userDataLoading ? (
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(15px)',
              borderRadius: '30px',
              boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
              border: '1px solid rgba(255,255,255,0.3)',
              overflow: 'hidden',
              marginBottom: '3rem'
            }}>
              {/* Header */}
              <div style={{
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                color: 'white',
                padding: '1.5rem 2.5rem',
                fontSize: '1.4rem',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                gap: '0.8rem'
              }}>
                👤 معلومات المستخدم الحالي
              </div>

              {/* Content */}
              <div style={{ padding: '2.5rem' }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '2rem'
                }}>
                  {/* User Name */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.2rem',
                    padding: '1.5rem',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.05) 100%)',
                    borderRadius: '20px',
                    border: '2px solid rgba(102, 126, 234, 0.1)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      borderRadius: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                    }}>
                      👤
                    </div>
                    <div>
                      <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                        اسم المستخدم
                      </div>
                      <div style={{ fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>
                        {userProfile.name}
                      </div>
                    </div>
                  </div>

                  {/* Role */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.2rem',
                    padding: '1.5rem',
                    background: 'linear-gradient(135deg, rgba(250, 112, 154, 0.1) 0%, rgba(254, 225, 64, 0.05) 100%)',
                    borderRadius: '20px',
                    border: '2px solid rgba(250, 112, 154, 0.1)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                      borderRadius: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      boxShadow: '0 8px 20px rgba(250, 112, 154, 0.3)'
                    }}>
                      🎯
                    </div>
                    <div>
                      <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                        الدور الوظيفي
                      </div>
                      <div style={{ fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>
                        {this.getRoleText(userProfile.role)}
                      </div>
                    </div>
                  </div>

                  {/* حالة استقبال الطلبات - فقط لكول سنتر */}
                  {userProfile.role === 0 && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1.2rem',
                      padding: '1.5rem',
                      background: userProfile.isOn ?
                        'linear-gradient(135deg, rgba(56, 239, 125, 0.1) 0%, rgba(17, 153, 142, 0.05) 100%)' :
                        'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(248, 113, 113, 0.05) 100%)',
                      borderRadius: '20px',
                      border: `2px solid ${userProfile.isOn ? 'rgba(56, 239, 125, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: userProfile.isOn ?
                          'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' :
                          'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                        borderRadius: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.4rem',
                        boxShadow: userProfile.isOn ?
                          '0 8px 20px rgba(17, 153, 142, 0.3)' :
                          '0 8px 20px rgba(239, 68, 68, 0.3)'
                      }}>
                        {userProfile.isOn ? '🟢' : '🔴'}
                      </div>
                      <div>
                        <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                          حالة استقبال الطلبات
                        </div>
                        <div style={{
                          fontSize: '1.2rem',
                          color: userProfile.isOn ? '#059669' : '#dc2626',
                          fontWeight: '700'
                        }}>
                          {userProfile.isOn ? 'نشط - يتلقى طلبات' : 'غير نشط'}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ساعة بداية الشفت - فقط لكول سنتر */}
                  {userProfile.role === 0 && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1.2rem',
                      padding: '1.5rem',
                      background: 'linear-gradient(135deg, rgba(79, 172, 254, 0.1) 0%, rgba(0, 242, 254, 0.05) 100%)',
                      borderRadius: '20px',
                      border: '2px solid rgba(79, 172, 254, 0.1)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                        borderRadius: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.4rem',
                        boxShadow: '0 8px 20px rgba(79, 172, 254, 0.3)'
                      }}>
                        🌅
                      </div>
                      <div>
                        <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                          بداية الشفت
                        </div>
                        <div style={{ fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>
                          {this.formatTime(userProfile.start)}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ساعة نهاية الشفت - فقط لكول سنتر */}
                  {userProfile.role === 0 && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1.2rem',
                      padding: '1.5rem',
                      background: 'linear-gradient(135deg, rgba(196, 113, 245, 0.1) 0%, rgba(250, 113, 205, 0.05) 100%)',
                      borderRadius: '20px',
                      border: '2px solid rgba(196, 113, 245, 0.1)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, #c471f5 0%, #fa71cd 100%)',
                        borderRadius: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.4rem',
                        boxShadow: '0 8px 20px rgba(196, 113, 245, 0.3)'
                      }}>
                        🌇
                      </div>
                      <div>
                        <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                          نهاية الشفت
                        </div>
                        <div style={{ fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>
                          {this.formatTime(userProfile.end)}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* صلاحيات كل الطلبات */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.2rem',
                    padding: '1.5rem',
                    background: userProfile.is_su ?
                      'linear-gradient(135deg, rgba(240, 147, 251, 0.1) 0%, rgba(245, 87, 108, 0.05) 100%)' :
                      'linear-gradient(135deg, rgba(156, 163, 175, 0.1) 0%, rgba(107, 114, 128, 0.05) 100%)',
                    borderRadius: '20px',
                    border: `2px solid ${userProfile.is_su ? 'rgba(240, 147, 251, 0.2)' : 'rgba(156, 163, 175, 0.2)'}`,
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '50px',
                      height: '50px',
                      background: userProfile.is_su ?
                        'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' :
                        'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)',
                      borderRadius: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      boxShadow: userProfile.is_su ?
                        '0 8px 20px rgba(240, 147, 251, 0.3)' :
                        '0 8px 20px rgba(156, 163, 175, 0.3)'
                    }}>
                      {userProfile.is_su ? '🔓' : '🔒'}
                    </div>
                    <div>
                      <div style={{ fontSize: '0.9rem', color: '#718096', fontWeight: '600', marginBottom: '0.3rem' }}>
                        صلاحية كل الطلبات
                      </div>
                      <div style={{
                        fontSize: '1.2rem',
                        color: userProfile.is_su ? '#c026d3' : '#6b7280',
                        fontWeight: '700'
                      }}>
                        {userProfile.is_su ? 'صلاحية على كل الطلبات' : 'صلاحية محدودة'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : userDataLoading ? (
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(15px)',
              borderRadius: '30px',
              boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
              border: '1px solid rgba(255,255,255,0.3)',
              padding: '3rem',
              textAlign: 'center',
              marginBottom: '3rem'
            }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1.5rem',
                animation: 'spin 1s linear infinite'
              }}>
                ⏳
              </div>
              <div style={{ fontSize: '1.3rem', fontWeight: '600', color: '#718096' }}>
                جاري تحميل معلومات المستخدم...
              </div>
            </div>
          ) : null}

          {/* Menu Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2.5rem'
          }}>
            {menuItems
              .filter(item => {
                // إخفاء العناصر المقيدة بدور معين إذا لم يكن المستخدم يملك هذا الدور
                if (item.roleRestriction !== undefined) {
                  return userProfile?.role === item.roleRestriction;
                }
                // إظهار باقي العناصر للجميع
                return true;
              })
              .map((item, index) => (
                <div
                  key={index}
                  style={{
                    position: 'relative',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '30px',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                    transition: 'all 0.4s ease',
                    cursor: 'pointer',
                    transform: 'translateY(0)',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.15)';
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    const overlay = e.currentTarget.querySelector('.overlay');
                    if (overlay) overlay.style.opacity = '0.1';
                    const icon = e.currentTarget.querySelector('.icon');
                    if (icon) {
                      icon.style.transform = 'scale(1.1) rotate(5deg)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    const overlay = e.currentTarget.querySelector('.overlay');
                    if (overlay) overlay.style.opacity = '0';
                    const icon = e.currentTarget.querySelector('.icon');
                    if (icon) {
                      icon.style.transform = 'scale(1) rotate(0deg)';
                    }
                  }}
                >
                  <div
                    className="overlay"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: item.color,
                      borderRadius: '30px',
                      opacity: 0,
                      transition: 'opacity 0.4s ease'
                    }}
                  />

                  <div style={{ padding: '2.5rem', position: 'relative', zIndex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '2rem' }}>
                      <div
                        className="icon"
                        style={{
                          width: '80px',
                          height: '80px',
                          background: item.color,
                          borderRadius: '25px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
                          transition: 'all 0.4s ease',
                          fontSize: '2.2rem'
                        }}
                      >
                        {item.icon}
                      </div>
                      <div style={{ color: '#cbd5e0', transition: 'color 0.3s ease' }}>
                        <svg style={{ width: '1.8rem', height: '1.8rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                      </div>
                    </div>

                    <h3 style={{
                      fontSize: 'clamp(1.2rem, 3vw, 1.6rem)',
                      fontWeight: '700',
                      color: '#2d3748',
                      marginBottom: '1rem',
                      transition: 'color 0.3s ease',
                      lineHeight: '1.3'
                    }}>
                      {item.title}
                    </h3>
                    <p style={{
                      color: '#718096',
                      marginBottom: '2rem',
                      lineHeight: '1.7',
                      fontSize: '1rem'
                    }}>
                      {item.description}
                    </p>

                    {item.link ? (
                      <a
                        href={item.link}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '1rem 2rem',
                          background: item.color,
                          color: 'white',
                          fontWeight: '600',
                          borderRadius: '20px',
                          textDecoration: 'none',
                          boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                          transition: 'all 0.3s ease',
                          fontSize: '1rem',
                          gap: '0.8rem'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                          e.target.style.boxShadow = '0 12px 30px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'scale(1)';
                          e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                        }}
                      >
                        الدخول الآن
                        <svg style={{ width: '1.2rem', height: '1.2rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                      </a>
                    ) : (
                      <button
                        onClick={item.action}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '1rem 2rem',
                          background: item.color,
                          color: 'white',
                          fontWeight: '600',
                          borderRadius: '20px',
                          border: 'none',
                          cursor: 'pointer',
                          boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                          transition: 'all 0.3s ease',
                          fontSize: '1rem',
                          gap: '0.8rem'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                          e.target.style.boxShadow = '0 12px 30px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'scale(1)';
                          e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                        }}
                      >
                        فتح الآن
                        <svg style={{ width: '1.2rem', height: '1.2rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Upsells Report Modal - فقط لكول سنتر */}
        {showUpsellsReport && userProfile?.role === 0 && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.7)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              zIndex: 1000,
              padding: window.innerWidth > 768 ? '2rem' : '0.5rem',
              overflowY: 'auto'
            }}
            onClick={this.toggleUpsellsReport}
          >
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                borderRadius: window.innerWidth > 768 ? '30px' : '20px',
                boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
                maxWidth: window.innerWidth > 768 ? '80rem' : '100%',
                width: '100%',
                maxHeight: window.innerWidth > 768 ? '90vh' : '100vh',
                overflowY: 'auto',
                border: '1px solid rgba(255,255,255,0.3)',
                marginTop: window.innerWidth > 768 ? '2rem' : '0'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div style={{
                padding: window.innerWidth > 768 ? '2.5rem 3rem 1.5rem 3rem' : '1.5rem 1rem 1rem 1rem',
                borderBottom: '3px solid rgba(17, 153, 142, 0.1)',
                position: 'sticky',
                top: 0,
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                borderTopLeftRadius: window.innerWidth > 768 ? '30px' : '20px',
                borderTopRightRadius: window.innerWidth > 768 ? '30px' : '20px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h2 style={{
                    fontSize: window.innerWidth > 768 ? '2.2rem' : '1.4rem',
                    fontWeight: '800',
                    color: '#2d3748',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: window.innerWidth > 768 ? '1rem' : '0.5rem',
                    lineHeight: '1.3'
                  }}>
                    💰 تقرير عمولات المبيعات الإضافية
                  </h2>
                  <button
                    onClick={this.toggleUpsellsReport}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                    style={{
                      width: window.innerWidth > 768 ? '3.5rem' : '2.5rem',
                      height: window.innerWidth > 768 ? '3.5rem' : '2.5rem',
                      background: 'rgba(239, 68, 68, 0.1)',
                      borderRadius: '50%',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      fontSize: window.innerWidth > 768 ? '1.4rem' : '1.2rem',
                      color: '#ef4444',
                      flexShrink: 0
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>

              {/* Modal Content */}
              <div style={{ padding: window.innerWidth > 768 ? '2.5rem 3rem' : '1rem' }}>
                {loading && (
                  <div style={{
                    textAlign: 'center',
                    padding: window.innerWidth > 768 ? '4rem' : '2rem',
                    color: '#11998e'
                  }}>
                    <div style={{
                      fontSize: window.innerWidth > 768 ? '3rem' : '2rem',
                      marginBottom: '1.5rem',
                      animation: 'spin 1s linear infinite'
                    }}>
                      ⏳
                    </div>
                    <div style={{ fontSize: window.innerWidth > 768 ? '1.4rem' : '1.1rem', fontWeight: '600' }}>
                      جاري تحميل البيانات...
                    </div>
                  </div>
                )}

                {error && !loading && (
                  <div style={{
                    background: 'rgba(239, 68, 68, 0.1)',
                    border: '3px solid rgba(239, 68, 68, 0.2)',
                    borderRadius: '20px',
                    padding: window.innerWidth > 768 ? '3rem' : '1.5rem',
                    textAlign: 'center',
                    color: '#ef4444',
                    marginBottom: '2rem'
                  }}>
                    <div style={{ fontSize: window.innerWidth > 768 ? '3rem' : '2rem', marginBottom: '1rem' }}>⚠️</div>
                    <div style={{ fontSize: window.innerWidth > 768 ? '1.4rem' : '1.1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                      خطأ في تحميل البيانات
                    </div>
                    <div style={{ fontSize: '1rem', color: '#991b1b' }}>
                      {error}
                    </div>
                    <button
                      onClick={() => this.fetchUpsellsData()}
                      style={{
                        marginTop: '1.5rem',
                        padding: '1rem 2rem',
                        background: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '15px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '1rem'
                      }}
                    >
                      إعادة المحاولة
                    </button>
                  </div>
                )}

                {upsellsData && !loading && !error && (
                  <>
                    {/* Summary Cards */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: window.innerWidth > 768 ? 'repeat(auto-fit, minmax(220px, 1fr))' : 'repeat(2, 1fr)',
                      gap: window.innerWidth > 768 ? '2rem' : '1rem',
                      marginBottom: window.innerWidth > 768 ? '3rem' : '2rem'
                    }}>
                      <div style={{
                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                        color: 'white',
                        padding: window.innerWidth > 768 ? '2rem' : '1rem',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        textAlign: 'center',
                        boxShadow: '0 15px 35px rgba(17, 153, 142, 0.3)'
                      }}>
                        <div style={{ fontSize: window.innerWidth > 768 ? '2.5rem' : '1.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                          {upsellsData.userReport.totalUpsellsOrders}
                        </div>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1rem' : '0.8rem', opacity: 0.9, fontWeight: '600' }}>
                          إجمالي الطلبات
                        </div>
                      </div>

                      <div style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        padding: window.innerWidth > 768 ? '2rem' : '1rem',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        textAlign: 'center',
                        boxShadow: '0 15px 35px rgba(102, 126, 234, 0.3)'
                      }}>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1.8rem' : '1.2rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                          {this.formatCurrency(upsellsData.userReport.totalCommission)}
                        </div>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1rem' : '0.8rem', opacity: 0.9, fontWeight: '600' }}>
                          إجمالي العمولة
                        </div>
                      </div>

                      <div style={{
                        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                        color: 'white',
                        padding: window.innerWidth > 768 ? '2rem' : '1rem',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        textAlign: 'center',
                        boxShadow: '0 15px 35px rgba(250, 112, 154, 0.3)'
                      }}>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1.6rem' : '1.1rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                          {this.formatCurrency(upsellsData.userReport.averageCommissionPerOrder)}
                        </div>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1rem' : '0.8rem', opacity: 0.9, fontWeight: '600' }}>
                          متوسط العمولة
                        </div>
                      </div>

                      <div style={{
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                        color: 'white',
                        padding: window.innerWidth > 768 ? '2rem' : '1rem',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        textAlign: 'center',
                        boxShadow: '0 15px 35px rgba(79, 172, 254, 0.3)'
                      }}>
                        <div style={{ fontSize: window.innerWidth > 768 ? '2rem' : '1.4rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                          {upsellsData.userReport.userPercentage}%
                        </div>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1rem' : '0.8rem', opacity: 0.9, fontWeight: '600' }}>
                          النسبة المئوية
                        </div>
                      </div>
                    </div>

                    {/* Orders Details */}
                    {upsellsData.userReport.orderDetails && upsellsData.userReport.orderDetails.length > 0 ? (
                      <div style={{
                        background: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        overflow: 'hidden',
                        border: '3px solid rgba(17, 153, 142, 0.1)',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
                      }}>
                        <div style={{
                          background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                          color: 'white',
                          padding: window.innerWidth > 768 ? '2rem' : '1rem',
                          fontSize: window.innerWidth > 768 ? '1.4rem' : '1.1rem',
                          fontWeight: '700'
                        }}>
                          📋 تفاصيل الطلبات والعمولات
                        </div>

                        {/* Mobile Cards View */}
                        {window.innerWidth <= 768 ? (
                          <div style={{ padding: '1rem' }}>
                            {upsellsData.userReport.orderDetails.map((order, index) => {
                              const calculationMethod = order.productCount === 1
                                ? `${upsellsData.userReport.userPercentage}% × 1`
                                : `${upsellsData.userReport.userPercentage}% + (${order.productCount - 1} × ${upsellsData.userReport.userPercentage / 2}%)`;

                              return (
                                <div
                                  key={order.orderId}
                                  style={{
                                    background: index % 2 === 0 ? 'white' : 'rgba(17, 153, 142, 0.02)',
                                    padding: '1rem',
                                    marginBottom: '1rem',
                                    borderRadius: '15px',
                                    border: '1px solid rgba(17, 153, 142, 0.1)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                  }}
                                >
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                                    <div style={{ fontWeight: '700', color: '#2d3748', fontSize: '1.1rem' }}>
                                      طلب #{order.orderId}
                                    </div>
                                    <span style={{
                                      background: order.productCount === 1 ? 'rgba(79, 172, 254, 0.1)' : 'rgba(250, 112, 154, 0.1)',
                                      color: order.productCount === 1 ? '#4facfe' : '#fa709a',
                                      padding: '0.3rem 0.8rem',
                                      borderRadius: '15px',
                                      fontWeight: '600',
                                      fontSize: '0.9rem'
                                    }}>
                                      {order.productCount} منتج
                                    </span>
                                  </div>

                                  <div style={{ marginBottom: '0.5rem' }}>
                                    <div style={{ fontSize: '0.85rem', color: '#718096', marginBottom: '0.2rem' }}>العمولة المحسوبة:</div>
                                    <div style={{ fontWeight: '700', color: '#11998e', fontSize: '1.2rem' }}>
                                      {this.formatCurrency(order.calculatedCommission)}
                                    </div>
                                  </div>

                                  <div>
                                    <div style={{ fontSize: '0.85rem', color: '#718096', marginBottom: '0.2rem' }}>طريقة الحساب:</div>
                                    <div style={{ fontSize: '0.8rem', color: '#4a5568', fontFamily: 'monospace' }}>
                                      {calculationMethod}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          /* Desktop Table View */
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                              <thead>
                                <tr style={{ background: 'rgba(17, 153, 142, 0.05)' }}>
                                  <th style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#4a5568', borderBottom: '2px solid rgba(17, 153, 142, 0.1)' }}>
                                    رقم الطلب
                                  </th>
                                  <th style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#4a5568', borderBottom: '2px solid rgba(17, 153, 142, 0.1)' }}>
                                    عدد المنتجات
                                  </th>
                                  <th style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#4a5568', borderBottom: '2px solid rgba(17, 153, 142, 0.1)' }}>
                                    العمولة المحسوبة
                                  </th>
                                  <th style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#4a5568', borderBottom: '2px solid rgba(17, 153, 142, 0.1)' }}>
                                    طريقة الحساب
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {upsellsData.userReport.orderDetails.map((order, index) => {
                                  const calculationMethod = order.productCount === 1
                                    ? `${upsellsData.userReport.userPercentage}% × 1`
                                    : `${upsellsData.userReport.userPercentage}% + (${order.productCount - 1} × ${upsellsData.userReport.userPercentage / 2}%)`;

                                  return (
                                    <tr
                                      key={order.orderId}
                                      style={{
                                        background: index % 2 === 0 ? 'white' : 'rgba(17, 153, 142, 0.02)',
                                        transition: 'background 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(17, 153, 142, 0.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = index % 2 === 0 ? 'white' : 'rgba(17, 153, 142, 0.02)';
                                      }}
                                    >
                                      <td style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#2d3748' }}>
                                        #{order.orderId}
                                      </td>
                                      <td style={{ padding: '1.5rem', textAlign: 'center' }}>
                                        <span style={{
                                          background: order.productCount === 1 ? 'rgba(79, 172, 254, 0.1)' : 'rgba(250, 112, 154, 0.1)',
                                          color: order.productCount === 1 ? '#4facfe' : '#fa709a',
                                          padding: '0.8rem 1.5rem',
                                          borderRadius: '25px',
                                          fontWeight: '700',
                                          fontSize: '1rem'
                                        }}>
                                          {order.productCount}
                                        </span>
                                      </td>
                                      <td style={{ padding: '1.5rem', textAlign: 'center', fontWeight: '700', color: '#11998e', fontSize: '1.1rem' }}>
                                        {this.formatCurrency(order.calculatedCommission)}
                                      </td>
                                      <td style={{ padding: '1.5rem', textAlign: 'center', fontSize: '0.9rem', color: '#718096' }}>
                                        {calculationMethod}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{
                        background: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: window.innerWidth > 768 ? '25px' : '15px',
                        padding: window.innerWidth > 768 ? '4rem' : '2rem',
                        textAlign: 'center',
                        border: '3px solid rgba(17, 153, 142, 0.1)',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
                      }}>
                        <div style={{ fontSize: window.innerWidth > 768 ? '4rem' : '3rem', marginBottom: '1.5rem' }}>📊</div>
                        <div style={{ fontSize: window.innerWidth > 768 ? '1.4rem' : '1.1rem', fontWeight: '600', color: '#4a5568', marginBottom: '0.8rem' }}>
                          لا توجد طلبات في الفترة المحددة
                        </div>
                        <div style={{ fontSize: '1rem', color: '#718096' }}>
                          جرب تغيير الفترة الزمنية للحصول على بيانات
                        </div>
                      </div>
                    )}

                    {/* Action Buttons */}
                    <div style={{
                      display: 'flex',
                      gap: '1.5rem',
                      marginTop: window.innerWidth > 768 ? '3rem' : '2rem',
                      justifyContent: 'center',
                      flexWrap: 'wrap'
                    }}>
                      <button
                        onClick={() => this.fetchUpsellsData()}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 15px 40px rgba(17, 153, 142, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 10px 30px rgba(17, 153, 142, 0.3)';
                        }}
                        style={{
                          padding: window.innerWidth > 768 ? '1.2rem 2.5rem' : '1rem 2rem',
                          background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: window.innerWidth > 768 ? '1.1rem' : '1rem',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 10px 30px rgba(17, 153, 142, 0.3)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.8rem'
                        }}
                      >
                        🔄 تحديث البيانات
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Search Modal */}
        {showSearch && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.7)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              padding: '2rem'
            }}
            onClick={this.toggleSearch}
          >
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                borderRadius: '30px',
                boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
                maxWidth: '35rem',
                width: '100%',
                padding: '3rem',
                border: '1px solid rgba(255,255,255,0.3)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem' }}>
                <h3 style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  color: '#2d3748',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.8rem'
                }}>
                  🔍 بحث عن طلب
                </h3>
                <button
                  onClick={this.toggleSearch}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                    e.target.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                    e.target.style.transform = 'scale(1)';
                  }}
                  style={{
                    width: '3rem',
                    height: '3rem',
                    background: 'rgba(239, 68, 68, 0.1)',
                    borderRadius: '50%',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    fontSize: '1.3rem',
                    color: '#ef4444'
                  }}
                >
                  ✕
                </button>
              </div>

              <div style={{ marginBottom: '2.5rem' }}>
                <label style={{
                  display: 'block',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  color: '#4a5568',
                  marginBottom: '1.2rem'
                }}>
                  رقم الوصل أو رقم الهاتف
                </label>
                <input
                  type="text"
                  value={searchValue}
                  onChange={this.handleSearchInputChange}
                  placeholder="أدخل الرقم هنا..."
                  style={{
                    width: '100%',
                    padding: '1.2rem 1.8rem',
                    border: '3px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '20px',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    boxSizing: 'border-box',
                    background: 'rgba(255, 255, 255, 0.8)'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 6px rgba(102, 126, 234, 0.1)';
                    e.target.style.background = 'white';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                    e.target.style.boxShadow = 'none';
                    e.target.style.background = 'rgba(255, 255, 255, 0.8)';
                  }}
                  onKeyPress={this.handleKeyPress}
                />
              </div>

              <div style={{ display: 'flex', gap: '1.5rem' }}>
                <button
                  onClick={this.handleSearch}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 15px 40px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.3)';
                  }}
                  style={{
                    flex: 1,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '1.2rem',
                    borderRadius: '20px',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)'
                  }}
                >
                  🔍 بحث
                </button>
                <button
                  onClick={this.toggleSearch}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(107, 114, 128, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(107, 114, 128, 0.1)';
                  }}
                  style={{
                    flex: 1,
                    background: 'rgba(107, 114, 128, 0.1)',
                    color: '#4a5568',
                    padding: '1.2rem',
                    borderRadius: '20px',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease'
                  }}
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Stats Modal */}
        {showStats && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.7)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              padding: '2rem'
            }}
            onClick={this.toggleStats}
          >
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                borderRadius: '30px',
                boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
                maxWidth: '40rem',
                width: '100%',
                padding: '3rem',
                border: '1px solid rgba(255,255,255,0.3)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                color: 'white',
                padding: '2rem',
                borderRadius: '25px',
                textAlign: 'center',
                boxShadow: '0 15px 35px rgba(79, 172, 254, 0.3)'
              }}>
                <div style={{ fontSize: '1.4rem', fontWeight: '600', marginBottom: '0.8rem' }}>
                  النسبة المتوقعة
                </div>
                <div style={{ fontSize: '3rem', fontWeight: '800' }}>
                  {data.Percentage}%
                </div>
              </div>
            </div>
          </div>
        )}

        {/* تحذير عدم استقبال الطلبات - فقط للكول سنتر */}
        {showInactiveWarning && userProfile?.role === 0 && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.8)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              padding: '2rem'
            }}
          >
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(20px)',
                borderRadius: '30px',
                boxShadow: '0 30px 100px rgba(239, 68, 68, 0.4)',
                maxWidth: '500px',
                width: '100%',
                padding: '3rem',
                border: '3px solid rgba(239, 68, 68, 0.2)',
                textAlign: 'center',
                animation: 'modalSlideIn 0.4s ease-out'
              }}
            >
              {/* أيقونة التحذير */}
              <div style={{
                width: '100px',
                height: '100px',
                background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '3rem',
                margin: '0 auto 2rem auto',
                boxShadow: '0 15px 40px rgba(239, 68, 68, 0.3)',
                animation: 'pulse 2s infinite'
              }}>
                ⚠️
              </div>

              {/* العنوان */}
              <h2 style={{
                fontSize: '2rem',
                fontWeight: '800',
                color: '#dc2626',
                margin: '0 0 1rem 0',
                lineHeight: '1.3'
              }}>
                تنبيه هام!
              </h2>

              {/* الرسالة */}
              <p style={{
                fontSize: '1.3rem',
                color: '#4a5568',
                lineHeight: '1.6',
                margin: '0 0 2.5rem 0',
                fontWeight: '600'
              }}>
                أنت حالياً <span style={{ color: '#dc2626', fontWeight: '800' }}>لا تستقبل طلبات</span>
                <br />
                يرجى التواصل مع المشرف لتفعيل استقبال الطلبات
              </p>

              {/* زر الموافقة */}
              <button
                onClick={this.closeInactiveWarning}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 20px 50px rgba(239, 68, 68, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 15px 35px rgba(239, 68, 68, 0.3)';
                }}
                style={{
                  padding: '1.2rem 3rem',
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  fontWeight: '700',
                  fontSize: '1.2rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 15px 35px rgba(239, 68, 68, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.8rem',
                  margin: '0 auto'
                }}
              >
                ✅ فهمت، موافق
              </button>

              {/* معلومة إضافية */}
              <div style={{
                marginTop: '2rem',
                padding: '1rem',
                background: 'rgba(239, 68, 68, 0.05)',
                borderRadius: '15px',
                border: '1px solid rgba(239, 68, 68, 0.1)'
              }}>
                <p style={{
                  fontSize: '0.9rem',
                  color: '#6b7280',
                  margin: 0,
                  lineHeight: '1.5'
                }}>
                  💡 <strong>نصيحة:</strong> تأكد من تفعيل حالة استقبال الطلبات من إعدادات حسابك
                </p>
              </div>
            </div>
          </div>
        )}

        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.05);
              }
            }

            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }

            @media (max-width: 768px) {
              .menu-grid {
                grid-template-columns: 1fr !important;
                gap: 2rem !important;
              }
            }

            @media (max-width: 480px) {
              .menu-grid {
                padding: 0 1rem;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default Home;